import React from 'react';
import WebsiteImage from 'components/WebsiteImage';
import { BackgroundImageContainer } from './styles';

const BackgroundImage = (props) => (
  <BackgroundImageContainer
    className="background-image"
    gatsbyImage={props?.image?.gatsbyImageData}
    objectFit={props?.objectFit}
  >
    <WebsiteImage {...props} />
  </BackgroundImageContainer>
);

export default BackgroundImage;
